import { __rest } from "tslib";
import * as React from 'react';
import { Switch, Route } from 'react-router';
export const DefaultRouteSwitch = (_a) => {
    var { paths, NotFound } = _a, props = __rest(_a, ["paths", "NotFound"]);
    return (React.createElement(Switch, Object.assign({}, props),
        paths.map(({ path, Component }) => (React.createElement(Route, { exact: true, key: path, path: path, component: Component }))),
        React.createElement(Route, { component: NotFound })));
};
DefaultRouteSwitch.displayName = 'DefaultRouteSwitch';
//# sourceMappingURL=DefaultRouteSwitch_v5.js.map